module.exports = __webpack_public_path__ + "img/mission_map.6a893fa1.svg";